import axios, { getRequestHeaders } from './axios.js';

export const getChatList = async ({limit, skip}) => {
  try {
    limit = limit || 500;
    skip = skip || 0;
    const response = await axios.get(`/chat/?limit=${limit}&skip=${skip}`, {
      headers: getRequestHeaders(),
    });
    return response;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const createChat = async (datasetId) => {
  try {
    const chatId = await axios.post(
      `/chat/?client_dataset_id=${datasetId}`,
      {},
      {
        headers: getRequestHeaders(),
      }
    );
    console.log("inside call chatId response is : \n" + chatId);
    return chatId;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const deleteChat = async (chatId) => {
  try {
    const Id = await axios.delete(`/chat/${chatId}/`, {
      headers: getRequestHeaders(),
    });
    return Id;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const updateChatLabel = async (chatId, newLabel) => {
  try {
    const response = await axios.patch(
      `/chat/${chatId}/update-label/`,
      {
        label: newLabel,
      },
      {
        headers: getRequestHeaders(),
      }
    );
    return response;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};
